/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: products/model.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../common/media";
import * as dependency_2 from "./../common/price";
import * as dependency_3 from "./../google/protobuf/timestamp";
import * as pb_1 from "google-protobuf";
export namespace products.v1 {
    export enum Status {
        STATUS_UNSPECIFIED = 0,
        STATUS_INACTIVE = 1,
        STATUS_ACTIVE = 2
    }
    export enum RuleType {
        RULE_TYPE_UNSPECIFIED = 0,
        RULE_TYPE_DIGITAL_NEWSPAPER = 1
    }
    export enum ProductType {
        PRODUCT_TYPE_UNSPECIFIED = 0,
        PRODUCT_TYPE_DIGITAL = 1,
        PRODUCT_TYPE_PHYSICAL = 2
    }
    export class Product extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            workspaceId?: string;
            sku?: string;
            name?: string;
            description?: string;
            attributes?: Attribute[];
            medias?: dependency_1.common.v1.Media[];
            status?: Status;
            tags?: Map<string, string>;
            metadata?: Map<string, string>;
            createdAt?: dependency_3.google.protobuf.Timestamp;
            updatedAt?: dependency_3.google.protobuf.Timestamp;
            createdBy?: string;
            updatedBy?: string;
            price?: dependency_2.common.v1.Price;
            organizationId?: string;
            productType?: ProductType;
            ruleType?: RuleType;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [6, 7], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("workspaceId" in data && data.workspaceId != undefined) {
                    this.workspaceId = data.workspaceId;
                }
                if ("sku" in data && data.sku != undefined) {
                    this.sku = data.sku;
                }
                if ("name" in data && data.name != undefined) {
                    this.name = data.name;
                }
                if ("description" in data && data.description != undefined) {
                    this.description = data.description;
                }
                if ("attributes" in data && data.attributes != undefined) {
                    this.attributes = data.attributes;
                }
                if ("medias" in data && data.medias != undefined) {
                    this.medias = data.medias;
                }
                if ("status" in data && data.status != undefined) {
                    this.status = data.status;
                }
                if ("tags" in data && data.tags != undefined) {
                    this.tags = data.tags;
                }
                if ("metadata" in data && data.metadata != undefined) {
                    this.metadata = data.metadata;
                }
                if ("createdAt" in data && data.createdAt != undefined) {
                    this.createdAt = data.createdAt;
                }
                if ("updatedAt" in data && data.updatedAt != undefined) {
                    this.updatedAt = data.updatedAt;
                }
                if ("createdBy" in data && data.createdBy != undefined) {
                    this.createdBy = data.createdBy;
                }
                if ("updatedBy" in data && data.updatedBy != undefined) {
                    this.updatedBy = data.updatedBy;
                }
                if ("price" in data && data.price != undefined) {
                    this.price = data.price;
                }
                if ("organizationId" in data && data.organizationId != undefined) {
                    this.organizationId = data.organizationId;
                }
                if ("productType" in data && data.productType != undefined) {
                    this.productType = data.productType;
                }
                if ("ruleType" in data && data.ruleType != undefined) {
                    this.ruleType = data.ruleType;
                }
            }
            if (!this.tags)
                this.tags = new Map();
            if (!this.metadata)
                this.metadata = new Map();
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get workspaceId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set workspaceId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get sku() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set sku(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get name() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set name(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get description() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set description(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get attributes() {
            return pb_1.Message.getRepeatedWrapperField(this, Attribute, 6) as Attribute[];
        }
        set attributes(value: Attribute[]) {
            pb_1.Message.setRepeatedWrapperField(this, 6, value);
        }
        get medias() {
            return pb_1.Message.getRepeatedWrapperField(this, dependency_1.common.v1.Media, 7) as dependency_1.common.v1.Media[];
        }
        set medias(value: dependency_1.common.v1.Media[]) {
            pb_1.Message.setRepeatedWrapperField(this, 7, value);
        }
        get status() {
            return pb_1.Message.getFieldWithDefault(this, 8, Status.STATUS_UNSPECIFIED) as Status;
        }
        set status(value: Status) {
            pb_1.Message.setField(this, 8, value);
        }
        get tags() {
            return pb_1.Message.getField(this, 9) as any as Map<string, string>;
        }
        set tags(value: Map<string, string>) {
            pb_1.Message.setField(this, 9, value as any);
        }
        get metadata() {
            return pb_1.Message.getField(this, 10) as any as Map<string, string>;
        }
        set metadata(value: Map<string, string>) {
            pb_1.Message.setField(this, 10, value as any);
        }
        get createdAt() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 11) as dependency_3.google.protobuf.Timestamp;
        }
        set createdAt(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 11, value);
        }
        get hasCreatedAt() {
            return pb_1.Message.getField(this, 11) != null;
        }
        get updatedAt() {
            return pb_1.Message.getWrapperField(this, dependency_3.google.protobuf.Timestamp, 12) as dependency_3.google.protobuf.Timestamp;
        }
        set updatedAt(value: dependency_3.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 12, value);
        }
        get hasUpdatedAt() {
            return pb_1.Message.getField(this, 12) != null;
        }
        get createdBy() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set createdBy(value: string) {
            pb_1.Message.setField(this, 13, value);
        }
        get updatedBy() {
            return pb_1.Message.getFieldWithDefault(this, 14, "") as string;
        }
        set updatedBy(value: string) {
            pb_1.Message.setField(this, 14, value);
        }
        get price() {
            return pb_1.Message.getWrapperField(this, dependency_2.common.v1.Price, 15) as dependency_2.common.v1.Price;
        }
        set price(value: dependency_2.common.v1.Price) {
            pb_1.Message.setWrapperField(this, 15, value);
        }
        get hasPrice() {
            return pb_1.Message.getField(this, 15) != null;
        }
        get organizationId() {
            return pb_1.Message.getFieldWithDefault(this, 16, "") as string;
        }
        set organizationId(value: string) {
            pb_1.Message.setField(this, 16, value);
        }
        get productType() {
            return pb_1.Message.getFieldWithDefault(this, 17, ProductType.PRODUCT_TYPE_UNSPECIFIED) as ProductType;
        }
        set productType(value: ProductType) {
            pb_1.Message.setField(this, 17, value);
        }
        get ruleType() {
            return pb_1.Message.getFieldWithDefault(this, 18, RuleType.RULE_TYPE_UNSPECIFIED) as RuleType;
        }
        set ruleType(value: RuleType) {
            pb_1.Message.setField(this, 18, value);
        }
        static fromObject(data: {
            id?: string;
            workspaceId?: string;
            sku?: string;
            name?: string;
            description?: string;
            attributes?: ReturnType<typeof Attribute.prototype.toObject>[];
            medias?: ReturnType<typeof dependency_1.common.v1.Media.prototype.toObject>[];
            status?: Status;
            tags?: {
                [key: string]: string;
            };
            metadata?: {
                [key: string]: string;
            };
            createdAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            updatedAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
            createdBy?: string;
            updatedBy?: string;
            price?: ReturnType<typeof dependency_2.common.v1.Price.prototype.toObject>;
            organizationId?: string;
            productType?: ProductType;
            ruleType?: RuleType;
        }): Product {
            const message = new Product({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.workspaceId != null) {
                message.workspaceId = data.workspaceId;
            }
            if (data.sku != null) {
                message.sku = data.sku;
            }
            if (data.name != null) {
                message.name = data.name;
            }
            if (data.description != null) {
                message.description = data.description;
            }
            if (data.attributes != null) {
                message.attributes = data.attributes.map(item => Attribute.fromObject(item));
            }
            if (data.medias != null) {
                message.medias = data.medias.map(item => dependency_1.common.v1.Media.fromObject(item));
            }
            if (data.status != null) {
                message.status = data.status;
            }
            if (typeof data.tags == "object") {
                message.tags = new Map(Object.entries(data.tags));
            }
            if (typeof data.metadata == "object") {
                message.metadata = new Map(Object.entries(data.metadata));
            }
            if (data.createdAt != null) {
                message.createdAt = dependency_3.google.protobuf.Timestamp.fromObject(data.createdAt);
            }
            if (data.updatedAt != null) {
                message.updatedAt = dependency_3.google.protobuf.Timestamp.fromObject(data.updatedAt);
            }
            if (data.createdBy != null) {
                message.createdBy = data.createdBy;
            }
            if (data.updatedBy != null) {
                message.updatedBy = data.updatedBy;
            }
            if (data.price != null) {
                message.price = dependency_2.common.v1.Price.fromObject(data.price);
            }
            if (data.organizationId != null) {
                message.organizationId = data.organizationId;
            }
            if (data.productType != null) {
                message.productType = data.productType;
            }
            if (data.ruleType != null) {
                message.ruleType = data.ruleType;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                workspaceId?: string;
                sku?: string;
                name?: string;
                description?: string;
                attributes?: ReturnType<typeof Attribute.prototype.toObject>[];
                medias?: ReturnType<typeof dependency_1.common.v1.Media.prototype.toObject>[];
                status?: Status;
                tags?: {
                    [key: string]: string;
                };
                metadata?: {
                    [key: string]: string;
                };
                createdAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
                updatedAt?: ReturnType<typeof dependency_3.google.protobuf.Timestamp.prototype.toObject>;
                createdBy?: string;
                updatedBy?: string;
                price?: ReturnType<typeof dependency_2.common.v1.Price.prototype.toObject>;
                organizationId?: string;
                productType?: ProductType;
                ruleType?: RuleType;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.workspaceId != null) {
                data.workspaceId = this.workspaceId;
            }
            if (this.sku != null) {
                data.sku = this.sku;
            }
            if (this.name != null) {
                data.name = this.name;
            }
            if (this.description != null) {
                data.description = this.description;
            }
            if (this.attributes != null) {
                data.attributes = this.attributes.map((item: Attribute) => item.toObject());
            }
            if (this.medias != null) {
                data.medias = this.medias.map((item: dependency_1.common.v1.Media) => item.toObject());
            }
            if (this.status != null) {
                data.status = this.status;
            }
            if (this.tags != null) {
                data.tags = (Object.fromEntries)(this.tags);
            }
            if (this.metadata != null) {
                data.metadata = (Object.fromEntries)(this.metadata);
            }
            if (this.createdAt != null) {
                data.createdAt = this.createdAt.toObject();
            }
            if (this.updatedAt != null) {
                data.updatedAt = this.updatedAt.toObject();
            }
            if (this.createdBy != null) {
                data.createdBy = this.createdBy;
            }
            if (this.updatedBy != null) {
                data.updatedBy = this.updatedBy;
            }
            if (this.price != null) {
                data.price = this.price.toObject();
            }
            if (this.organizationId != null) {
                data.organizationId = this.organizationId;
            }
            if (this.productType != null) {
                data.productType = this.productType;
            }
            if (this.ruleType != null) {
                data.ruleType = this.ruleType;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.workspaceId.length)
                writer.writeString(2, this.workspaceId);
            if (this.sku.length)
                writer.writeString(3, this.sku);
            if (this.name.length)
                writer.writeString(4, this.name);
            if (this.description.length)
                writer.writeString(5, this.description);
            if (this.attributes.length)
                writer.writeRepeatedMessage(6, this.attributes, (item: Attribute) => item.serialize(writer));
            if (this.medias.length)
                writer.writeRepeatedMessage(7, this.medias, (item: dependency_1.common.v1.Media) => item.serialize(writer));
            if (this.status != Status.STATUS_UNSPECIFIED)
                writer.writeEnum(8, this.status);
            for (const [key, value] of this.tags) {
                writer.writeMessage(9, this.tags, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            for (const [key, value] of this.metadata) {
                writer.writeMessage(10, this.metadata, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (this.hasCreatedAt)
                writer.writeMessage(11, this.createdAt, () => this.createdAt.serialize(writer));
            if (this.hasUpdatedAt)
                writer.writeMessage(12, this.updatedAt, () => this.updatedAt.serialize(writer));
            if (this.createdBy.length)
                writer.writeString(13, this.createdBy);
            if (this.updatedBy.length)
                writer.writeString(14, this.updatedBy);
            if (this.hasPrice)
                writer.writeMessage(15, this.price, () => this.price.serialize(writer));
            if (this.organizationId.length)
                writer.writeString(16, this.organizationId);
            if (this.productType != ProductType.PRODUCT_TYPE_UNSPECIFIED)
                writer.writeEnum(17, this.productType);
            if (this.ruleType != RuleType.RULE_TYPE_UNSPECIFIED)
                writer.writeEnum(18, this.ruleType);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Product {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Product();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.workspaceId = reader.readString();
                        break;
                    case 3:
                        message.sku = reader.readString();
                        break;
                    case 4:
                        message.name = reader.readString();
                        break;
                    case 5:
                        message.description = reader.readString();
                        break;
                    case 6:
                        reader.readMessage(message.attributes, () => pb_1.Message.addToRepeatedWrapperField(message, 6, Attribute.deserialize(reader), Attribute));
                        break;
                    case 7:
                        reader.readMessage(message.medias, () => pb_1.Message.addToRepeatedWrapperField(message, 7, dependency_1.common.v1.Media.deserialize(reader), dependency_1.common.v1.Media));
                        break;
                    case 8:
                        message.status = reader.readEnum();
                        break;
                    case 9:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.tags as any, reader, reader.readString, reader.readString));
                        break;
                    case 10:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.metadata as any, reader, reader.readString, reader.readString));
                        break;
                    case 11:
                        reader.readMessage(message.createdAt, () => message.createdAt = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 12:
                        reader.readMessage(message.updatedAt, () => message.updatedAt = dependency_3.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 13:
                        message.createdBy = reader.readString();
                        break;
                    case 14:
                        message.updatedBy = reader.readString();
                        break;
                    case 15:
                        reader.readMessage(message.price, () => message.price = dependency_2.common.v1.Price.deserialize(reader));
                        break;
                    case 16:
                        message.organizationId = reader.readString();
                        break;
                    case 17:
                        message.productType = reader.readEnum();
                        break;
                    case 18:
                        message.ruleType = reader.readEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Product {
            return Product.deserialize(bytes);
        }
    }
    export class Attribute extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            key?: string;
            value?: string;
            unit?: string;
            displayName?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("key" in data && data.key != undefined) {
                    this.key = data.key;
                }
                if ("value" in data && data.value != undefined) {
                    this.value = data.value;
                }
                if ("unit" in data && data.unit != undefined) {
                    this.unit = data.unit;
                }
                if ("displayName" in data && data.displayName != undefined) {
                    this.displayName = data.displayName;
                }
            }
        }
        get key() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set key(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get value() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set value(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get unit() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set unit(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get displayName() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set displayName(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            key?: string;
            value?: string;
            unit?: string;
            displayName?: string;
        }): Attribute {
            const message = new Attribute({});
            if (data.key != null) {
                message.key = data.key;
            }
            if (data.value != null) {
                message.value = data.value;
            }
            if (data.unit != null) {
                message.unit = data.unit;
            }
            if (data.displayName != null) {
                message.displayName = data.displayName;
            }
            return message;
        }
        toObject() {
            const data: {
                key?: string;
                value?: string;
                unit?: string;
                displayName?: string;
            } = {};
            if (this.key != null) {
                data.key = this.key;
            }
            if (this.value != null) {
                data.value = this.value;
            }
            if (this.unit != null) {
                data.unit = this.unit;
            }
            if (this.displayName != null) {
                data.displayName = this.displayName;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.key.length)
                writer.writeString(1, this.key);
            if (this.value.length)
                writer.writeString(2, this.value);
            if (this.unit.length)
                writer.writeString(3, this.unit);
            if (this.displayName.length)
                writer.writeString(4, this.displayName);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Attribute {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Attribute();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.key = reader.readString();
                        break;
                    case 2:
                        message.value = reader.readString();
                        break;
                    case 3:
                        message.unit = reader.readString();
                        break;
                    case 4:
                        message.displayName = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Attribute {
            return Attribute.deserialize(bytes);
        }
    }
}
